import type { DlvyBox, Order, OrderSnapshot, OrdInfo } from "@wowpress/types"

export function ordInfoToSnapshot(order: Order): OrderSnapshot {
  return {
    orderNo: order.orderNo,
    title: order.title || "주문 제목",
    orderDate: order.orderDate,
    orderStatus: order.orderStatus,
    jobStatus: order.jobStatus,
    shippingInfo: order.shippingInfo,
    amount: order.amount,
    raw: order.raw,
  }
}
